import { fixFloatNumber, pp, px, styled, calculateDisplayRect, } from '@tencent/exeditor3-ui-kit/dist/resizer/utils.js';
export const raf = (fn) => window.requestAnimationFrame(fn);
export { fixFloatNumber, pp, px, styled, calculateDisplayRect };
export const pick = (obj, array) => {
    const result = {};
    array.forEach((key) => {
        if (Object.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key];
        }
    });
    return result;
};
export const parseAspectRatio = (str) => {
    if (str.includes(':')) {
        const peer = str.split(':').map((s) => parseFloat(s));
        return peer[0] / peer[1];
    }
    return parseFloat(str) || 0;
};
export const parseAngleStringToRad = (str) => {
    if (/rad/.test(str)) {
        return parseFloat(str);
    }
    if (/turn/.test(str)) {
        const turn = parseFloat(str);
        return turn * 2 * Math.PI;
    }
    if (/deg/.test(str)) {
        const deg = parseFloat(str);
        return (deg / 180) * Math.PI;
    }
    // 默认作为弧度
    return parseFloat(str);
};
export const stringifyRadToDegree = (rad) => {
    if (rad === 0) {
        return '0';
    }
    const deg = (rad / Math.PI) * 180;
    return `${fixFloatNumber(deg)}deg`;
};
export const parseCropDetail = (str) => {
    const pieces = str.split(';');
    const numbers = pieces.map((p) => parseFloat(p));
    return {
        width: numbers[0],
        height: numbers[1],
        x: numbers[2] || 0,
        y: numbers[3] || 0,
    };
};
export const stringifyCropDetail = (detail) => {
    const pieces = [detail.width, detail.height, detail.x, detail.y].map((num) => fixFloatNumber(num, 6));
    return pieces.join(';');
};
export const getImageMetaInfo = (imageAttributes) => new Promise((resolve) => {
    const image = new Image();
    image.addEventListener('load', () => {
        resolve({
            width: image.naturalWidth,
            height: image.naturalHeight,
        });
        image.remove();
    });
    Object.assign(image, imageAttributes);
});
export const base64StringToTypedArray = (str) => {
    const text = atob(str);
    const arr = new Uint8Array(text.length);
    for (let i = 0; i < text.length; i++) {
        arr[i] = text.charCodeAt(i);
    }
    return arr;
};
//# sourceMappingURL=utils.js.map